export const STANDARD_HTTP_HEADERS = {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
    'X-Noyo-API-Version': '1.0.0',
    'Noyo-User-Agent': 'Noyo/ReactWeb 1.0'
};
